var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class LgDigitalSignage {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.videoSelection = '001'; // HDMI 1
        this.volume = '050';
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'power',
                regExp: /:01([SG])000([0-3])/i,
                callback: (match) => {
                    if (match[1].toUpperCase() === 'S') {
                        this.power = match[2] === '3';
                        this.socket.send(`401+`);
                    }
                    else {
                        this.socket.send(`:01r000${this.power ? '3' : '2'}`);
                    }
                },
            },
            {
                name: 'videoInput',
                regExp: /:01([SG]):(\d{3})/i,
                callback: (match) => {
                    if (match[1].toUpperCase() === 'S') {
                        this.videoSelection = match[2];
                        this.socket.send(`401+`);
                    }
                    else {
                        this.socket.send(`:01r:${this.videoSelection}`);
                    }
                },
            },
            {
                name: 'volume',
                regExp: /:01([SG])8(\d{3})/i,
                callback: (match) => {
                    if (match[1].toUpperCase() === 'S') {
                        this.volume = match[2];
                        this.socket.send(`401+`);
                    }
                    else {
                        this.socket.send(`:01r8${this.volume.padStart(3, '0')}`);
                    }
                },
            },
            {
                name: 'volumeMute',
                regExp: /:01([SG])900([01])/i,
                callback: (match) => {
                    if (match[1].toUpperCase() === 'S') {
                        this.volumeMute = match[2] === '1';
                        this.socket.send(`401+`);
                    }
                    else {
                        this.socket.send(`:01r900${this.volumeMute ? '1' : '0'}`);
                    }
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 4664 || this.power);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 4664 || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '001';
    }
}
LgDigitalSignage.emulatorType = 'socketEmulator';
LgDigitalSignage.key = '-NT9AL2ERn8Waf7roCL0';
